// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1_mwH","cls2":"NewsHeader-cls2_VYx NewsHeader-cls1_mwH"};